class EstSection extends HTMLElement {
    constructor() {
        super();
        // this.googleAPIKey = "AIzaSyCUG_kV7SVC3nKjmp3vN8dszrI74Wx3cF4";
        this.googleAPIKey = this.dataset.googleApi;
        this.bespokeShippingAPIKey = this.dataset.bespokeApi;
        this.domain = this.dataset.domain;
        this.input = this.querySelector("form input");
        this.submitButton = this.querySelector("#est-button");
        this.resultElm = this.querySelector("#est-result");
        this.elmMsgError = this.querySelector("#est-err");
        this.prodHandle = this.dataset.productHandle;
        // this.dataStore = this.getDataStore();

        this.input.addEventListener("input", this.inputHandle.bind(this));
        this.querySelector("form").addEventListener("submit", this.submitHandle.bind(this));
        this.querySelector("#est-current-location").addEventListener("click", this.getLocation.bind(this));
        this.popupHandle();

        // POC Render Locations on popup
        let self = this;
        setTimeout(function() { self.getLocationsData(); }, 1000);

        // Check boms kit
        const element = document.querySelector('[data-sku]');
        const sku = element.getAttribute('data-sku');

        if (sku.startsWith('.')) {
          const estMessage = document.querySelector('.est-result__cbm-message');
          const estStoreStock = document.querySelector('.est-result__stores');
          estMessage.style.display = 'none';
          estStoreStock.style.display = 'none';
        } else {

        }
        setHeight = this.resultElm.scrollHeight + "px";
        this.resultElm.style.maxHeight = 'unset';
    }
    inputHandle(e) {
        let valueInput = e.target.value;
        let haveValue = dataPostCode().filter((data) => data.includes(valueInput.toUpperCase()));
        let limitArray = haveValue.slice(0, 50);
        autocomplete(this.input, limitArray);
        // const numberRegex = /^\d+$/;
        // let valueOk = numberRegex.test(valueInput) && Number(valueInput) >= 2000 && Number(valueInput) < 10000;
        let valueOk = valueInput.length > 3;
        // this.submitButton.disabled = !valueOk;
        this.submitButton.classList.toggle("disabled", !valueOk);
    }
    async submitHandle(e) {
        e.preventDefault();
        this.elmMsgError.textContent = "";
        let msgErr = "";
        let msg1 = this.elmMsgError.dataset.msgEmpty;
        let msg2 = this.elmMsgError.dataset.msgOutside;
        let msgUrl = this.elmMsgError.dataset.contactUrl;
        let setHeight = 0;
        this.submitButton.classList.add("loading");
       
        // this.dataStore = this.getDataStore();
        let postcode = '';
        let suburb = '';
        if (!this.input.value.includes(',')) {
            msgErr = msg1;
        } else { 
            postcode = this.input.value.split(",")[0].trim();
            suburb = this.input.value.split(",")[1].trim();
            msgErr = '';
        };        
        // console.log(this.dataStore);
        if (postcode == '' || suburb == '') {
            msgErr = msg1;
        } else { 
            if (dataPostCode().includes(this.input.value.toUpperCase())) {            
                let dataLocation = await this.googleRequestLocationByCode(postcode, suburb);
                if (dataLocation === false) { 
                    msgErr = '';
                }
               
                    // let { latitude, longitude } = dataLocation;
                    // this.nearestStoreName = this.getNearestStore(latitude, longitude) ? this.getNearestSt ore(latitude, longitude).name : false;
                    this.currentPostCode = postcode;
                    
                    let ratesPrice = await this.requestRate();

                    if (ratesPrice && ratesPrice.rates.length > 0) {
                        let deliveryPrice = ratesPrice.rates.find(r => r.service_name == 'Delivery');

                        if (deliveryPrice) {
                            this.querySelector("#EST-delivery_rate").textContent = `Delivery Rate: ${window.Shopify.formatMoney(deliveryPrice.total_price)}`;
                            this.getLocationsData();
                            setHeight = this.resultElm.scrollHeight + "px";
                            msgErr = '';
                        } else {
                            this.querySelector("#EST-delivery_rate").textContent = "Only available for pickup";
                            this.getLocationsData();
                            setHeight = this.resultElm.scrollHeight + "px";
                            msgErr = msg2;
                        }
                    } else {
                        msgErr = msg2;
                    }
                
            } else {
                msgErr = msg2;
            }
        }

        if (msgErr == msg2) {
            this.elmMsgError.innerHTML = msgErr.includes('Contact Us') ? msgErr.replace(`Contact Us`, `<a href="${msgUrl}" target="_blank">Contact Us</a>`) : msgErr.replace(`contact us`, `<a href="${msgUrl}" target="_blank">contact us</a>`);
        } else { 
            this.elmMsgError.textContent = msgErr;
        }
     
        this.resultElm.style.maxHeight = setHeight;
        this.submitButton.classList.remove("loading");
    }
    popupHandle() {
        const id = this.getAttribute("data-id");
        const popup = document.querySelector(`#PopupModal-${id}`);
        let listBtn = popup.querySelectorAll(".est-tab-headers button");
        let listContent = popup.querySelectorAll(".est-tab-contents .tab-content");
        const classActive = "est-tab_active";
        listBtn.forEach((btn, index) => {
            if (btn.classList.contains(classActive)) listContent[index].classList.add(classActive);
            btn.addEventListener("click", (e) => {
                listBtn.forEach((b) => b.classList.remove(classActive));
                listContent.forEach((c) => c.classList.remove(classActive));
                btn.classList.add(classActive);
                listContent[index].classList.add(classActive);
            });
        });
        document.querySelector(`#CloseModal-${id}`).addEventListener("click", (e) => popup.hide());
    }
    async getLocation(e) {
        let msg = "";
        if (navigator.geolocation) {
            let { latitude, longitude } = await this.getCurrentLocation();
            let dataCurrentLocation = await this.googleRequestLocationByLatLon(latitude, longitude);
            let goodPostCode =
                dataCurrentLocation.dataPostCode && dataPostCode().filter((data) => data.includes(dataCurrentLocation.dataPostCode.toUpperCase()));
            let goodLocality =
                goodPostCode &&
                dataCurrentLocation.dataLocality &&
                goodPostCode.filter((data) => data.includes(dataCurrentLocation.dataLocality.toUpperCase()));
            if (goodLocality && goodLocality.length > 0) {
                this.input.value = goodLocality[0];
                this.input.dispatchEvent(new Event("input", { bubbles: true }));
                // this.nearestStoreName = this.getNearestStore(latitude, longitude) ? this.getNearestStore(latitude, longitude).name : false;
                this.currentPostCode = goodLocality[0].split(",")[0];
                return;
            } else {
                msg = "Sorry we currently cannot lookup your location. Please re-try or manually enter.";
            }
        } else {
            msg = " (Geolocation is not supported by this browser.)";
        }
        this.input.value = "";
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
        this.elmMsgError.textContent = msg;
        this.resultElm.style.maxHeight = 0;
    }
    async getCurrentLocation() {
        const pos = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
        });

        return {
            longitude: pos.coords.longitude,
            latitude: pos.coords.latitude,
        };
    }
    async googleRequestLocationByCode(postCode, locality) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?components=administrative_area:${encodeURI(
            locality
        )}|postal_code_prefix:${postCode}|country:AU&key=${this.googleAPIKey}`;
        let res = await fetch(url);
        let data = await res.json();
        console.log(data);
        if (data.status != "OK") return false;
        this.dataCurrentLocation = data.results;
        return {
            latitude: data.results[0].geometry.location.lat,
            longitude: data.results[0].geometry.location.lng,
        };
    }
    async googleRequestLocationByLatLon(latitude, longitude) {
        // latitude = -29.816553; // data to test
        // longitude = 133.461611; // data to test
        let res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&sensor=true&key=${this.googleAPIKey}`);
        let data = await res.json();
        // console.log(data);
        if (data.status != "OK") return false;
        this.dataCurrentLocation = data.results;
        let dataPostCode = data.results
            .map((r) => r.address_components)
            .map((r) => r.find((i) => i.types.includes("postal_code")))
            .filter((u) => u !== undefined)
            .map((p) => p.long_name)[0];
        let dataLocality = data.results
            .map((r) => r.address_components)
            .map((r) => r.find((i) => i.types.includes("locality") || i.types.includes("political")))
            .filter((u) => u !== undefined)
            .map((p) => p.long_name)[0];
        return {
            dataPostCode,
            dataLocality,
        };
    }
    async requestRate() {
        let headersList = {
            "Content-type": "application/json",
            HTTP_X_STORE_NAME: this.domain,
            HTTP_X_STORE_TOKEN: "4ef84fdd9ea3528eebc5a9eeb10ec2f154ab3e44",
        };
        // format data destination
        const address_components = this.dataCurrentLocation[0].address_components;
        const addressClient = {
            country: address_components.find((c) => c.types.includes("country")).short_name,
            // postal_code: address_components.find((c) => c.types.includes("postal_code")) ? address_components.find((c) => c.types.includes("postal_code")).long_name : this.currentPostCode,
            postal_code: this.currentPostCode,
            province: address_components.find((c) => c.types.includes("administrative_area_level_1") || c.types.includes("political")).short_name,
            city: address_components.find(
                (c) => c.types.includes("administrative_area_level_2") || c.types.includes("locality") || c.types.includes("political")
            ).long_name,
            address1: this.dataCurrentLocation[0].formatted_address,
            address2: "",
            phone: null,
        };

        let currentVariant = JSON.parse(document.querySelector("[data-current-variant-json]").textContent);

        // let nearestStore = this.dataStore.find((s) => s.name == this.nearestStoreName);
        // if (!nearestStore) return false;
        let nearestStore = {
            address: { 
                country: "Australia",
                country_code: "AU",
                zip: "2164",
                province: "New South Wales",
                province_code: "NSW",
                city: "Wetherill Park",
                name: "",
                address1: "29 Elizabeth Street",
                address2: null,
                address3: null,
                phone: "02 9616 6600",
                fax: null,
                address_type: null,
                company_name: "1825 Interiors",
            }            
        }
        let dataRequest = {
            origin: {
                // store
                country: nearestStore.address.country_code,
                postal_code: nearestStore.address.zip,
                province: nearestStore.address.province_code,
                city: nearestStore.address.city,
                name: nearestStore.address.name,
                address1: nearestStore.address.address1,
                address2: nearestStore.address.address2,
                address3: null,
                phone: nearestStore.address.phone,
                fax: null,
                address_type: null,
                company_name: nearestStore.address.company_name,
            },
            destination: {
                // address
                country: addressClient.country,
                postal_code: addressClient.postal_code,
                province: addressClient.province,
                city: addressClient.city,
                name: this.dataset.customerName || "Passing guests",
                address1: addressClient.address1,
                address2: addressClient.address2,
                address3: null,
                phone: addressClient.phone,
                fax: null,
                address_type: null,
                company_name: "",
            },
            items: [
                {
                    name: currentVariant.name,
                    sku: currentVariant.sku,
                    quantity: (document.querySelector('[name="quantity"]') && document.querySelector('[name="quantity"]').value) || 1,
                    grams: null,
                    price: currentVariant.price,
                    vendor: this.dataset.productVendor,
                    requires_shipping: currentVariant.requires_shipping,
                    taxable: currentVariant.taxable,
                    fulfillment_service: "manual",
                    properties: null,
                    product_id: Number(this.dataset.productId),
                    variant_id: currentVariant.id,
                },
            ],
            currency: window.Shopify.currency.active,
        };
        // console.log(dataRequest);
        let bodyContent = JSON.stringify(dataRequest);
        // console.log(bodyContent);
        let response = await fetch("https://parcel-intelligence.com/cs/api_ex.php", {
            method: "POST",
            body: bodyContent,
            headers: headersList,
        });
        let data = await response.json();
        return data;
    }
    getNearestStore(latitude, longitude) {
        const distance = (lat1, lon1, lat2, lon2, unit) => {
            var radlat1 = (Math.PI * lat1) / 180;
            var radlat2 = (Math.PI * lat2) / 180;
            var theta = lon1 - lon2;
            var radtheta = (Math.PI * theta) / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = (dist * 180) / Math.PI;
            dist = dist * 60 * 1.1515;
            // M is statute miles (default)
            if (unit == "K") {
                //K is kilometers
                dist = dist * 1.609344;
            }
            if (unit == "N") {
                // N is nautical miles
                dist = dist * 0.8684;
            }
            return dist;
        };

        const availableStoreLatlng = this.dataStore
            .filter((d) => d.available)
            .map((l) => {
                return {
                    long: distance(latitude, longitude, l.lat, l.lon, "K"),
                    name: l.name,
                };
            });
        return availableStoreLatlng.length > 0 ? availableStoreLatlng.reduce((pre, cur) => (cur.long < pre.long ? cur : pre)) : false;
    }

    // getDataStore() {
    //     return Array.from(this.querySelectorAll("[data-product-stores-stock] > li")).map((location) => {
    //         return {
    //             available: JSON.parse(location.dataset.available),
    //             lat: Number(location.dataset.lat),
    //             lon: Number(location.dataset.lon),
    //             name: location.dataset.name,
    //             address: JSON.parse(location.dataset.address),
    //         };
    //     });
    // }

    getLocationsData() { 
        if (window.inventoryInfo) {          
            console.log('Data rendered');
            const { variantLocations } = window.inventoryInfo[this.prodHandle].data;
            if (variantLocations) this.buildResultStores(variantLocations);            
        } else {
            console.log('Data was not rendered');
        }
    }

    buildResultStores(data) { 
        let currentVariant = JSON.parse(document.querySelector("[data-current-variant-json]").textContent);
        // console.log(currentVariant.id)
        let variantLocations = data.find(location => location.variant == currentVariant.id);
        let allLocationsArr = variantLocations.inventoryLocations;
        // console.log(variantLoallLocationsArrcations)
        let list = document.querySelector('.est-result__stores');   
        list.innerHTML = ``;
        allLocationsArr.forEach(elm => { 
            let item = `<li class="${elm.location.name == 'WETHERILL PARK' ? 'hidden' : ''}">            
                <span class="uppercase">${elm.location.name}</span>
                ${elm.quantity > 0
                    ? `<span class="est-result__in">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M22 11.0801V12.0001C21.9988 14.1565 21.3005 16.2548 20.0093 17.9819C18.7182 19.7091 16.9033 20.9726 14.8354 21.584C12.7674 22.1954 10.5573 22.122 8.53447 21.3747C6.51168 20.6274 4.78465 19.2462 3.61096 17.4372C2.43727 15.6281 1.87979 13.4882 2.02168 11.3364C2.16356 9.18467 2.99721 7.13643 4.39828 5.49718C5.79935 3.85793 7.69279 2.71549 9.79619 2.24025C11.8996 1.76502 14.1003 1.98245 16.07 2.86011" stroke="#27AE60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M22 4L12 14.01L9 11.01" stroke="#27AE60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            In Stock
                            </span>`
                    : `<span class="est-result__out">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M22 11.0801V12.0001C21.9988 14.1565 21.3005 16.2548 20.0093 17.9819C18.7182 19.7091 16.9033 20.9726 14.8354 21.584C12.7674 22.1954 10.5573 22.122 8.53447 21.3747C6.51168 20.6274 4.78465 19.2462 3.61096 17.4372C2.43727 15.6281 1.87979 13.4882 2.02168 11.3364C2.16356 9.18467 2.99721 7.13643 4.39828 5.49718C5.79935 3.85793 7.69279 2.71549 9.79619 2.24025C11.8996 1.76502 14.1003 1.98245 16.07 2.86011" stroke="#27AE60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M22 4L12 14.01L9 11.01" stroke="#27AE60" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            ON ORDER - Lead Times Apply
                            </span>`
                }
            </li>`;        
            list.innerHTML += item;
        })
    }
}

customElements.define("est-section", EstSection);

function autocomplete(inp, arr) {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    var currentFocus;
    /*execute a function when someone writes in the text field:*/
    var a,
        b,
        i,
        val = inp.value;
    /*close any already open lists of autocompleted values*/
    closeAllLists();
    if (!val) {
        return false;
    }
    currentFocus = -1;
    /*create a DIV element that will contain the items (values):*/
    a = document.createElement("DIV");
    a.setAttribute("id", inp.id + "autocomplete-list");
    a.setAttribute("class", "autocomplete-items");
    /*append the DIV element as a child of the autocomplete container:*/
    inp.parentNode.appendChild(a);
    /*for each item in the array...*/
    for (i = 0; i < arr.length; i++) {
        /*check if the item starts with the same letters as the text field value:*/
        // if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
        /*create a DIV element for each matching element:*/
        b = document.createElement("DIV");
        /*make the matching letters bold:*/
        // b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
        // b.innerHTML += arr[i].substr(val.length);
        b.innerHTML += `${arr[i].replace(val.toUpperCase(), `<strong>${val.toUpperCase()}</strong>`)}`;
        /*insert a input field that will hold the current array item's value:*/
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
        /*execute a function when someone clicks on the item value (DIV element):*/
        b.addEventListener("click", function (e) {
            /*insert the value for the autocomplete text field:*/
            inp.value = this.getElementsByTagName("input")[0].value;
            inp.dispatchEvent(new Event("input", { bubbles: true }));
            /*close the list of autocompleted values,
                (or any other open lists of autocompleted values:*/
            closeAllLists();
        });
        a.appendChild(b);
        // }
    }

    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function (e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
            /*If the arrow DOWN key is pressed,
          increase the currentFocus variable:*/
            currentFocus++;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 38) {
            //up
            /*If the arrow UP key is pressed,
          decrease the currentFocus variable:*/
            currentFocus--;
            /*and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode == 13) {
            /*If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) {
                /*and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click();
            }
        }
    });

    function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }
    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
      except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
}
